<template>
    <modal name="update_group" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update group')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-multi-lang-input id="name"
                                          v-model="form.name"
                                          name="name"
                                          rules="required"
                                          :langs="locales && Object.keys(locales)">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-multi-lang-input>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import VehicleGroupService from '@services/vehicleGroup.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            loading: false,
            group_id: null
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    VehicleGroupService.update(this.group_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setGroup', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const group = event.params.group;
            if (group) {
                this.form.name = Object.assign({}, group.name);
                this.group_id = group.id;
            }
        },
        hide() {
            this.$modal.hide('update_group');
        }
    }
};
</script>
